import React, { FC } from 'react';
import SelectOption from '../../../@types/SelectOption';
import { Select as MuiSelect, MenuItem, FormControl, Stack, Typography } from '@mui/material';
import { SelectInputProps } from '@mui/material/Select/SelectInput';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';

interface SelectProps extends SelectInputProps {
   label: string;
   value: string;
   options: SelectOption[];
   defaultValue?: string;  
   loading?: boolean;
}

const Select: FC<SelectProps> = ({ label, value, defaultValue, options, loading, ...props }) => {

   return (
      <FormControl disabled={props?.disabled}>
         <Stack
            direction="column"
            spacing={0.5}
            width="100%">
            <Typography variant="secondaryFont">
               {label}
            </Typography>
            <MuiSelect
               value={value}
               defaultValue={defaultValue}
               {...props}
               sx={{
                  minWidth: '225px',
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                     borderImage: 'linear-gradient(#c2171d, #ff9e2d) 30%;',
                     borderWidth: '2px'
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                     borderImage: 'linear-gradient(#c2171d, #ff9e2d) 30%;',
                     borderWidth: '2px'
                  }
               }}
               displayEmpty>
               {options.map((option, index) =>
                  <MenuItem
                     key={index}
                     value={option.value}
                     disabled={option.disabled}>
                     <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>{option.label} {option.disabled && option.disabledMessage ? option.disabledMessage : ''}</Typography>
                        <LoadingIndicator loading={loading ?? false} size={20} />
                     </Stack>
                  </MenuItem>
               )}
            </MuiSelect>
         </Stack>
      </FormControl>
   );
}

export default Select;
